import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { clearTitleData } from '../../actions/titleActions';
import { setFullHeight } from '../../actions/uiActions';
import { loadTimelineData, setTimelineEra, setActiveSlideIndex } from '../../actions/timelineTitleActions';
import { RedirectAs404 } from '../Error404';
import ContainerDimensions from 'react-container-dimensions';
import { EraControl, CategoryKey, Slides, Controller, Nav } from '../Timeline';


class TimelineTitle extends Component {
  constructor (props) {
    super(props);
    this.renderChildRoutes = this.renderChildRoutes.bind(this);
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { actions, history, location, match, staticContext, ...rest } = this.props;
    actions.loadTimelineData(rest);
    actions.setFullHeight(true);
  }

  componentWillUnmount () {
    const { actions, uid } = this.props;
    actions.clearTitleData(uid);
  }

  renderChildRoutes () {
    const { uid, actions, match, eras, slides } = this.props;
    if (eras.length) {
      return [
        <Route exact key="timeline-index" path={match.url} render={props => {
          // Redirect to first slide of first era
          return <Redirect to={`${match.url}/${eras[0].slug}/1`} />;
        }} />,
        <Route exact key="timeline-era-index" path={`${match.url}/:eraSlug`} render={props => {
          const { eraSlug } = props.match.params;
          // Validate that slug URL param matches an existing era object
          return eras.find(era => era.slug === eraSlug) ? <Redirect to={`${props.match.url}/1`} /> : <RedirectAs404 />;
        }} />,
        <Route exact key="timeline-era-slide" path={`${match.url}/:eraSlug/:slideIndex`} render={props => {
          const { eraSlug, slideIndex } = props.match.params;
          // Validate era
          const era = eras.find(era => era.slug === eraSlug);
          if (!era) {
            return <RedirectAs404 />;
          }
          // Validate slide index
          const index = parseInt(slideIndex, 10);
          if (isNaN(index) || index < 1 || index > era.slides.length) {
            return <RedirectAs404 />;
          }
          actions.setTimelineEra(uid, eraSlug);
          actions.setActiveSlideIndex(uid, index - 1);
          return null;
        }} />,
        <Route key="error" component={RedirectAs404} />,
      ];
    } else {
      return [
        <Route exact key="timeline-index" path={match.url} render={props => {
          // Redirect to first slide
          return <Redirect to={`${match.url}/1`} />;
        }} />,
        <Route exact key="timeline-slide" path={`${match.url}/:slideIndex`} render={props => {
          const { slideIndex } = props.match.params;
          // Validate slide index
          const index = parseInt(slideIndex, 10);
          if (isNaN(index) || index < 1 || index > slides.length) {
            return <RedirectAs404 />;
          }
          actions.setActiveSlideIndex(uid, index - 1);
          return null;
        }} />,
        <Route key="error" component={RedirectAs404} />,
      ];
    }
  }

  render () {
    const { dataLoaded, eras, uid: titleId } = this.props;
    if (!dataLoaded) {
      return null;
    }

    return (
      <div className="title-wrapper">
        <Switch>
          {this.renderChildRoutes()}
          <Route key="timeline-notfound" component={RedirectAs404} />
        </Switch>

        <div className="timeline-outer">
          <div className="timeline-container">
            {eras.length ? (
              <header className="timeline-header">
                <div className="row no-gutters align-items-end">
                  <div className="col-12 col-lg-6">
                    <EraControl titleId={titleId} />
                  </div>
                </div>
              </header>
            ) : null}

            <ContainerDimensions>
              {({ width }) => (
                <div className="timeline-stage">
                  <Slides key={`${titleId}-slides`} titleId={titleId} containerWidth={width} />
                  <Controller key={`${titleId}-controller`} titleId={titleId} containerWidth={width} />
                  <div className="d-none d-lg-block" style={{ position: 'absolute', top: 'calc(100% + 10px)', width: '100%' }}>
                    <CategoryKey key={`${titleId}-categoryKey`} titleId={titleId} />
                  </div>
                  <Nav titleId={titleId} />
                </div>
              )}
            </ContainerDimensions>
          </div>
        </div>
      </div>
    );
  }
}

TimelineTitle.propTypes = {
  uid: PropTypes.string.isRequired,
  name: PropTypes.string,
  slug: PropTypes.string.isRequired,
  eras: PropTypes.arrayOf(PropTypes.object),
  slides: PropTypes.arrayOf(PropTypes.object),
};

TimelineTitle.defaultProps = {
  eras: [],
  slides: [],
};

const mapStateToProps = ({ titles }, ownProps) => ({
  dataLoaded: Object.keys(titles).indexOf(ownProps.uid) > -1,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ clearTitleData, loadTimelineData, setTimelineEra, setActiveSlideIndex, setFullHeight }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimelineTitle));



// WEBPACK FOOTER //
// ./src/components/Title/TimelineTitle.js